import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";
import { migrateElement } from "./social-icons-migration";
import { SocialLinkProps } from "./social-links-types";

function SocialLinks(props: SocialLinkProps) {
  const wuiltContext = useElements();
  const element = migrateElement(props.value?.id, props.value as any);

  if (element?.settings?.hidden) {
    return null;
  }

  return (
    <ElementsViewer.SocialLinks
      element={element}
      wuiltContext={wuiltContext}
      customClassNames={{
        itemClass: props.itemClass,
        listClass: props.listClass,
        navLinksColor: props.navLinksColor,
        hiddenClass: "",
      }}
    />
  );
}

export default SocialLinks;
